import React, { useEffect, useState } from 'react';
import Select from "react-select";
import swal from 'sweetalert';

import { Container } from "./styles";

function Dashboard() {
    const [jsonListaLotes, setJsonListaLotes] = useState([]);
    const [listaLotes, setListaLotes] = useState([]);
    const [selectedOptionLote, setSelectedOptionLote] = useState(null);
    const [listaCobrancas, setListaCobrancas] = useState([]);

    useEffect(() => {
        //Verifica se tem algum usuário logadoa  
        let produtor = localStorage.getItem("produtor");
        let cliente = localStorage.getItem("cliente");

        getLotes(cliente, produtor);
    }, []);

    async function getLotes(cliente, produtor) {
        setJsonListaLotes([]);
        setListaLotes([]);

        await fetch('https://lpsistemas.dev.br/adm/api/produtor/services/processalotes.php?cliente=' + cliente +
            '&produtor=' + produtor)
            .then((response) => response.json())
            .then((responseJson) => {
                setJsonListaLotes(responseJson);

                let vArrayData = [];
                let vdata = [];
                for (var [key, value] of Object.entries(responseJson)) {
                    vdata = {
                        "label": value.desclote,
                        "value": value.lote
                    }

                    vArrayData.push(vdata);
                }

                setListaLotes(vArrayData);
            });
    }

    function processaCobrancas() {
        return (
            <div style={{
                marginBottom: 40,
                marginTop: 15,
                borderRadius: 5,
                marginLeft: 15
            }} className="list-group">
                {listaCobrancas.map((item, index) => (
                    <div style={{
                        marginBottom: 5,
                        backgroundColor: '#fffff',
                        cursor: 'pointer',
                        height: 190
                    }} key={index} href="#"
                        className="list-group-item list-group-item-action flex-column align-items-start">

                        <div style={{ marginBottom: -25 }} className="d-flex w-100 justify-content-between">
                            <h6 style={{ marginLeft: -12, fontWeight: 'bold', fontSize: 15 }}
                                className="mb-1">Nº Título: {item.titulo + ' - ' + item.mes_ano}</h6>
                            <small>{item.id}</small>
                        </div>

                        <hr style={{ marginLeft: -10 }} />

                        <div className="d-flex w-100 justify-content-between">
                            <label style={{ marginLeft: -12, fontSize: 16, fontWeight: 'bold', color: 'red', marginTop: -5 }}>
                                <span style={{ color: 'black' }} >Vencimento:</span> {item.vencimento} </label>
                        </div>
                        <div className="d-flex w-100 justify-content-between">
                            <label style={{ marginLeft: -12, fontSize: 16, fontWeight: 'bold', color: 'red', marginTop: -5 }}>
                                <span style={{ color: 'black' }} >Valor:</span> {item.valor} </label>
                        </div>
                        <div className="d-flex w-100 justify-content-between" style={{ marginTop: -20 }} >
                            <h6 style={{ marginLeft: -12, fontWeight: 'bold' }}
                                className="mb-1">Linha digitável: {item.linha_digitavel}</h6>
                            <small>{item.id}</small>
                        </div>
                        <center>
                            <div style={{ marginLeft: -25, marginTop: 10 }} >
                                <button style={{ marginRight: 7 }} onClick={() => handleClipeBoard(item.linha_digitavel)} type="button" class="btn btn-success">Área de transferência</button>
                                <button onClick={() => viewPDF(item.titulo,
                                    item.boleto_ftp)} type="button" class="btn btn-primary">Visualizar anexo</button>
                            </div>
                        </center>

                        <hr style={{ marginLeft: -10 }} />
                    </div>
                ))}
            </div>
        );
    }

    async function getListCobrancas() {
        if (selectedOptionLote) {
            let produtor = localStorage.getItem("produtor");
            let cliente = localStorage.getItem("cliente");
            
            let lote = selectedOptionLote.value;

            if (lote) {
                await fetch('https://lpsistemas.dev.br/adm/api/produtor/services/gettitulos.php?produtor=' + produtor +
                    '&idcliente=' + cliente + '&lote=' + lote)
                    .then((response) => response.json())
                    .then((responseJson) => {
                        setListaCobrancas(responseJson);
                    });
            }
        }
    }

    const viewPDF = (titulo, bolftp) => {
        let cliente = localStorage.getItem("cliente");
        let vLinkPDF = `https://lpsistemas.dev.br/adm/api/produtor/services/gettitulopdf.php?idcliente=${cliente}&titulo=${titulo}`;
        window.open(vLinkPDF, "_blank");
    }

    function handleClipeBoard(text) {
        /* Copy the text inside the text field */
        navigator.clipboard.writeText(text);

        /* Alert the copied text */
        swal("Área de transferência", "Cópia efetuada com sucesso!");
    }

    return (
        <Container>
            <label>Lotes</label>

            <div style={{ width: '100%' }} >
                <Select
                    placeholder='Selecione um lote...'
                    defaultValue={selectedOptionLote}
                    onChange={setSelectedOptionLote}
                    options={listaLotes}
                />

                <div style={{ marginTop: 10 }} >
                    <label style={{ fontSize: 17, marginTop: 3, textDecorationLine: 'underline' }} ></label>
                    <button onClick={() => getListCobrancas()} style={{ marginLeft: 5, float: 'right' }}
                        className='btn btn-success' >Mostrar cobranças</button>
                </div>
            </div>

            <br />

            {processaCobrancas()}
        </Container>
    );
}

export default Dashboard;